/**
 * Prevents mobile devices from zooming in on inputs when they gain focus and the font-size is lower than 16px.
 * This is the default behaviour of iOS Safari, what is mostly bad UX as it does not zoom out ideally again.
 */
export async function preventMobileZoom() {
    let inputs = document.querySelectorAll('input, select, textarea');

    if (inputs.length) {
        let { initPreventMobileZoom } = await import(/* webpackMode: "lazy" */ './inc/prevent-mobile-zoom.async');

        initPreventMobileZoom(inputs);
    }
}
